var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 27.3994C17.0703 27.3994 17.5 27.8291 17.5 28.3369C17.5 28.8447 17.0703 29.2744 16.5625 29.2744H13.75C11.6797 29.2744 10 27.5947 10 25.5244V15.5244C10 13.4541 11.6797 11.7744 13.75 11.7744H16.5625C17.0703 11.7744 17.5 12.2041 17.5 12.7119C17.5 13.2197 17.0703 13.6494 16.5625 13.6494H13.75C12.7344 13.6494 11.875 14.5088 11.875 15.5244V25.5244C11.875 26.54 12.7344 27.3994 13.75 27.3994H16.5625ZM29.6875 19.8604C29.8828 20.0166 30 20.251 30 20.5244C30 20.7979 29.8828 21.0713 29.6875 21.2275L23.7109 26.4619C23.4766 26.6572 23.1641 26.7744 22.8516 26.7744C22.6953 26.7744 22.5 26.7354 22.3047 26.6572C21.875 26.4619 21.5625 25.9932 21.5625 25.4854V23.3369H16.875C16.0156 23.3369 15.3125 22.6338 15.3125 21.7744V19.2744C15.3125 18.415 16.0156 17.7119 16.875 17.7119H21.5625V15.5635C21.5625 15.0557 21.875 14.5869 22.3047 14.3916C22.7734 14.1963 23.3594 14.2744 23.7109 14.5869L29.6875 19.8604ZM23.4375 24.1963L27.6562 20.5244L23.4375 16.8525V19.5869H17.1875V21.4619H23.4375V24.1963Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.1545d8e6b32adfd20497fa84f5fa02df.svg";
export { ForwardRef as ReactComponent };